import React from 'react';

import ProjectCard from '@components/ProjectCard/ProjectCard.web';
import { Box } from '@components/Restyle';
import GlobalSearchList from '@components/Search/GlobalSearchList.web';
import { ProjectListRowSkeleton } from '@components/shared/skeletons';
import { Project } from '@graphql/generated';
import { Search } from '@root/types';

interface IProjectsSearch {
  search: string;
  data: Search<Project>[];
  loading?: boolean;
  sectionFooter?: JSX.Element;
  filterPart?: JSX.Element;
  totalCount?: number;
  hasError?: boolean;
  onPress?: (item: Project) => void;
  onEndReached?: (info: { distanceFromEnd: number }) => void;
}

// ProjectListRowSkeleton has no horizontal padding of its own — other
// screens that already use it wrap it in their own padded container.
// Global Search's real ProjectCard row applies `paddingHorizontal='l'`
// itself (isGlobalSearch branch), so match it here rather than changing
// the shared composite (TA-10278).
const renderProjectListRowSkeleton = (index: number) => (
  <Box key={index} testID='project-search-skeleton-row' paddingHorizontal='l'>
    <ProjectListRowSkeleton />
  </Box>
);

const ProjectsSearch: React.FC<IProjectsSearch> = ({
  search,
  data,
  loading = false,
  sectionFooter,
  filterPart,
  onPress,
  totalCount,
  hasError = false,
  onEndReached,
}) => {
  return (
    <Box flex={1}>
      <GlobalSearchList
        onEndReached={onEndReached}
        search={search}
        loading={loading}
        isViewAllContacts={false}
        onPress={() => {}}
        hasError={hasError}
        skeletonRow={renderProjectListRowSkeleton}
        lists={[
          {
            title: 'Projects',
            data: data,
            headerLeft: filterPart,
            totalCount:
              totalCount ?? (data.length > 0 ? data[0].total : data.length),
            render: (item) => {
              const project = item.record as Project;

              return (
                <Box accessibilityLabel='Project Item'>
                  <ProjectCard
                    filterVal={search}
                    project={project}
                    onClick={() => {
                      onPress?.(project);
                    }}
                    expanded={false}
                    isGlobalSearch
                  />
                </Box>
              );
            },
            sectionHeaderMarginBottom: 'xs',
            sectionFooter: sectionFooter,
          },
        ]}
      />
    </Box>
  );
};

export default ProjectsSearch;
